/* Bind the production update monitor to React; clean up listeners during StrictMode remounts. */
import { useEffect, useRef, useState } from 'react';
import { AppUpdateState, monitorAppUpdates } from '../services/appUpdateService';

export function useAppUpdate() {
  const [state, setState] = useState<AppUpdateState>({ available: false, refreshing: false, error: null });
  const monitor = useRef<ReturnType<typeof monitorAppUpdates>>();

  useEffect(() => {
    if (!import.meta.env.PROD) return;
    const current = monitorAppUpdates(setState);
    monitor.current = current;
    return () => current.dispose();
  }, []);

  return { ...state, refresh: () => monitor.current?.refresh() };
}
